module.exports = __webpack_public_path__ + "img/jk9.bf9c2ffc.png";